import { render } from "./artigoTransfer.vue?vue&type=template&id=21bde5b1&scoped=true"
import script from "./artigoTransfer.vue?vue&type=script&lang=js"
export * from "./artigoTransfer.vue?vue&type=script&lang=js"

import "./artigoTransfer.vue?vue&type=style&index=0&id=21bde5b1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bde5b1"]])

export default __exports__